module.exports = __webpack_public_path__ + "static/media/S_J.878daf44.png";